import * as yup from 'yup';
import { sharedApeironFields } from '../shared/sharedApeironSchema';

export const carApeironSchemaBuilder = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => yup.object({
    ...sharedApeironFields(
        firstDriverAdditionalPremiumAge,
        secondDriverAdditionalPremiumAge,
        firstDriverAdditionalPremiumLicenseYears,
        secondDriverAdditionalPremiumLicenseYears,
        legalEntity,
        secondDriver,
        discountEntity,
        vehicleType
    ),
});

export default carApeironSchemaBuilder;
